import classNames from 'classnames';
import React, {useState} from 'react';
import {WithRouterProps} from 'react-router';

import appStore from 'client/AppStore';
import Assignment from './Assignment';
import AssignmentStatusDropdown, {Value as DropdownValue} from './AssignmentStatusDropdown';
import {LoadingSpinner} from '@albert-io/atomic';
import TabEmptyState from '../TabEmptyState';
import {useStudentDashboard} from 'client/Classrooms/StudentDashboard/StudentDashboard.store';
import useStudentAssignments from './hooks/useStudentAssignments';

export default function StudentHomepageAssignmentsTabContent({params}: WithRouterProps) {
  const isMobile = appStore.isMobileView();
  const areClassroomsLoading = useStudentDashboard((state) => state.areClassroomsLoading);

  const classroomId: string | undefined = params.classroomId;

  const [dropdownValue, setDropdownValue] = useState<DropdownValue>('toDo');

  // This query will always get open assignments regardless of the current dropdown state in order to
  // provide an accurate empty state for "To-Do" assignments
  const {data: allData, loading: loadingAll} = useStudentAssignments(classroomId, 'all');
  const openAssignments = allData?.currentUser?.studentAssignments.results ?? [];

  const {data, loading} = useStudentAssignments(classroomId, dropdownValue);
  const assignments = data?.currentUser?.studentAssignments.results ?? [];

  const isLoading = areClassroomsLoading || loading || loadingAll;

  return (
    <div
      className={classNames('relative flex flex-col gap-x2 py-x3', {
        'px-x1': isMobile,
        'px-x4': !isMobile
      })}
    >
      <AssignmentStatusDropdown
        className='mb-x1'
        disabled={isLoading}
        isScopedToClassroom={classroomId !== undefined}
        onValueChange={setDropdownValue}
        value={dropdownValue}
      />
      {isLoading && (
        <div className='absolute left-x0 flex h-full w-full items-center justify-center'>
          <LoadingSpinner bottomMarginLevel={0} size={3} />
        </div>
      )}
      {!isLoading && assignments.length === 0 && (
        <TabEmptyState
          copy={
            dropdownValue === 'toDo' && openAssignments.length > 0
              ? 'No upcoming assignments'
              : 'Your assignments will appear here'
          }
          icon={['fal', 'file-alt']}
        />
      )}
      {!isLoading &&
        assignments.length > 0 &&
        assignments.map((assignment) => (
          <Assignment assignment={assignment} key={assignment.assignmentId} />
        ))}
    </div>
  );
}
